// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5c1f7d94","361":"d313abfe","455":"3bac69c0","925":"2ad89f6f","977":"fcdaa5f1"}[chunkId] + ".chunk.js";
};